import React, { forwardRef } from "react";
import { Search, X } from "lucide-react";
import { Input } from "../../atoms/Input/Input";
import { Icon } from "../../atoms/Icon/Icon";
import { cn } from "../../lib/cn";

type SearchInputProps = React.ComponentPropsWithoutRef<typeof Input> & {
  onClear?: () => void;
};

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className = "", value, onClear, ...props }, ref) => {
    const showClear = Boolean(value) && Boolean(onClear);
    return (
      <div className="relative">
        <span className="pointer-events-none absolute inset-y-0 left-3 flex items-center text-text-subtle">
          <Icon icon={Search} size="sm" />
        </span>
        <Input ref={ref} value={value} className={cn("pl-9", showClear && "pr-9", className)} {...props} />
        {showClear && (
          <button
            type="button"
            onClick={onClear}
            aria-label="Clear search"
            className="absolute inset-y-0 right-3 flex items-center text-text-subtle hover:text-text"
          >
            <Icon icon={X} size="sm" />
          </button>
        )}
      </div>
    );
  }
);
SearchInput.displayName = "SearchInput";
